import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import { AlertTitle, IconButton } from "@mui/material";
import Alert from "components/shared/Alert";
import useGlobalBannerConfig from "hooks/useGlobalBannerConfig";
import { GLOBAL_BANNER_DISMISSED_VERSION } from "./GlobalBanner.constants";

export type TGlobalBannerProps = {
  dismissible?: boolean;
};

const GlobalBanner = ({ dismissible = false }: TGlobalBannerProps) => {
  const { t } = useTranslation("common");
  const { globalBannerConfig, isSuccess } = useGlobalBannerConfig();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    const isDismissed =
      globalBannerConfig?.version ===
      localStorage.getItem(GLOBAL_BANNER_DISMISSED_VERSION);

    if (isSuccess && globalBannerConfig?.active && !isDismissed) {
      setIsOpen(true);
    }
  }, [globalBannerConfig, isSuccess, setIsOpen]);

  const handleDismiss = useCallback(
    (version: string) => {
      localStorage.setItem(GLOBAL_BANNER_DISMISSED_VERSION, version);

      setIsOpen(false);
    },
    [setIsOpen],
  );

  return (
    <>
      {isOpen && globalBannerConfig && (
        <Alert
          severity="info"
          square
          action={
            dismissible ? (
              <IconButton
                color="inherit"
                size="small"
                aria-label={t("button.dismiss")}
                onClick={() => handleDismiss(globalBannerConfig!.version)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            ) : null
          }
        >
          <AlertTitle>{globalBannerConfig.title}</AlertTitle>
          {globalBannerConfig.message}
        </Alert>
      )}
    </>
  );
};

export default GlobalBanner;
